
import {Component, Vue} from 'vue-property-decorator';
import {v4 as uuidv4} from 'uuid';
import {ElForm} from "element-ui/types/form";
import {PcForm} from "@/api/priceclass/types";
import {create} from "@/api/priceclass";

@Component({
  name: "PriceClassForm",
})
export default class PriceClassForm extends Vue {
  private showAddPricingClass = false; // 添加定价等级-弹窗隐显

  private form: PcForm = {
    name: null,
    coefficients: [],
  };

  private rules = {
    name: [
      {required: true, message: "请填写定价等级", trigger: "change"},
      {
        required: true,
        validator: (rule, value, callback) => {
          const regex = /^T(\d+(\.\d{1,4})?)$/;
          if (regex.test(value)) {
            if (value == 'T0') {
              callback(new Error("T0 是系统定价等级，禁止创建"))
              return;
            }
            callback();
          } else {
            callback(new Error('名称必须以 T 开头，并且 T 后面为正小数，精度不超过 4 位'));
          }
        },
        trigger: 'change'
      },
      {
        required: true,
        validator: (rule, value, callback) => {
          if (this.form.coefficients.length === 0) {
            callback(new Error("请至少填写一个定价系数"))
            return;
          }
          callback()
        },
        trigger: "change"
      }
    ]
  }

  private pricingClassTableCol = [
    {
      label: "系数名称",
      prop: "name",
      key: "name",
      type: 'input',
      maxlength: 64,
      show: true,
      disabled: false,
      check: {
        prefix: 'coefficients',
        rules: [
          {
            required: true,
            message: "请输入系数名称",
            trigger: "change"
          },
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              console.log(rule)
              console.log(value)
              const idx = rule.field.split('.')[1];
              const dup = this.form.coefficients.filter((item, index) => {
                return idx != index && item.name === value;
              })
              if (dup && dup.length > 0) {
                callback(new Error("系数名称不能重复"))
                return;
              }
              callback()
            },
          }
        ],
      }
    },
    {
      label: "系数",
      prop: "value",
      key: "value",
      type: 'inputNumber',
      min: 0.0001,
      max: 10.0000,
      precision: 4,
      show: true,
      disabled: false,
      check: {
        prefix: 'coefficients',
        rules: [{
          required: true,
          message: "请输入系数",
          trigger: "change"
        }],
      }
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "移除",
          code: "",
          click: "handleDelete",
          type: 'delete'
        }
      ],
      show: true,
      disabled: false,
      width: 260,
    }
  ];

  public show() {
    this.showAddPricingClass = true;
  }

  public close() {
    this.showAddPricingClass = false;
  }

  private handleDelete(row) {
    this.form.coefficients = this.form.coefficients.filter(item => item.id !== row.row.id);
  }

  private addPricingClass() {
    this.form.coefficients.push({
      name: null,
      value: null,
      id: uuidv4()
    });
  }

  private confirm() {
    (this.$refs['form'] as ElForm).validate((valid) => {
      if (valid) {
        create(this.form)
            .then(() => {
              this.$message.success("操作成功");
              this.$emit("confirm")
            })
            .finally(() => {
              this.close()
            })
      }
    })
  }
}
